// src/footerConfigs.js

export const footerConfigs = {
  "bheema": {
   brandName: "S.K Eng Medium School,Hunasagi",
    contact: "9449162639,9110277300 ,8431680334 | skschool@gmail.com",
    socialLinks: {
      instagram: "https://www.instagram.com/s.k_school_hunasagi/",
           whatsapp:   "https://wa.me/yourwhatsapplink",
           youtube:    "https://www.youtube.com/",
           facebook:   "https://www.facebook.com/profile.php?id=100095415130334",
           twitter:    "https://twitter.com"
    }
  },

  "acmeCorp": {
    brandName: "ACME Corporation",
    contact: "1800-ACME | support@acme.com",
    socialLinks: {
      instagram: "https://instagram.com/acmecorp",
      whatsapp:   "",
      youtube:    "https://youtube.com/acmecorp",
      facebook:   "https://facebook.com/acmecorp",
      twitter:    "https://twitter.com/acmecorp"
    }
  }

  // add more customer configs here...
};
